import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
  memoryLocalCache,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDNuPsRWdUZit-D4Qo80G1EiHo454IZtLE",
  authDomain: "soko-water-tank-monitor.firebaseapp.com",
  projectId: "soko-water-tank-monitor",
  storageBucket: "soko-water-tank-monitor.firebasestorage.app",
  messagingSenderId: "762180742554",
  appId: "1:762180742554:web:44d7b741ab6fa313109e23",
  measurementId: "G-XV1XGGMNCX"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Firestore transport: AUTO-DETECT long-polling (not FORCED). We previously
// forced long-polling to work around a first-load hang — but that hang was the
// service worker aborting Firestore's streaming connection (now fixed: the SW no
// longer intercepts firestore.googleapis.com). Forced long-polling is the
// transport that recovers WORST after a mobile background/sleep (a dead long-poll
// doesn't re-establish without a full reload). Auto-detect uses fast WebChannel
// streaming where the browser supports it, which reconnects gracefully on resume,
// and still falls back to long-polling where it's actually needed. Transport-only:
// same document read/write counts, so it's billing-neutral.
const FS_TRANSPORT = { experimentalAutoDetectLongPolling: true };

// Offline persistence: cache reads in IndexedDB so last-known tank levels render
// instantly with no connection (the dashboard's "last seen" line is the honesty
// signal for staleness).
//
// persistentSingleTabManager({ forceOwnership: true }) — NOT the multi-tab
// manager. In an installed PWA the OS can freeze a backgrounded webview without
// releasing the IndexedDB persistence lease; the multi-tab manager then makes a
// fresh launch WAIT on that dead lease, so Firestore never finishes initializing
// and every data page hangs on its spinner (fixed only by a full device reboot —
// killing the app doesn't release the frozen lease). forceOwnership makes a new
// launch SEIZE the cache instead of waiting, which is the correct choice for a
// single-instance PWA and eliminates that wedge. Trade-off: if two browser tabs
// are open at once, the newer one owns the cache and the older falls back to
// online-only — acceptable, and far better than a hang.
//
// If IndexedDB is unavailable or persistence can't initialize for any reason, we
// fall back to an in-memory cache rather than letting a cache failure strand the
// whole app. Reads/writes are unaffected (billing-neutral); only offline recall
// is lost in that fallback.
function makeDb() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentSingleTabManager({ forceOwnership: true }) }),
      ...FS_TRANSPORT,
    });
  } catch (e) {
    console.warn('Firestore persistent cache unavailable — using memory cache:', e);
    return initializeFirestore(app, { localCache: memoryLocalCache(), ...FS_TRANSPORT });
  }
}

export const db = makeDb();
// Region must match the cloud-side onCall region (us-central1 in
// functions/index.js). Mismatch causes an opaque "internal" error
// at call time, not a friendly 404.
export const functions = getFunctions(app, 'us-central1');
export default app;
export { app };